// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/index." + {"98":"ed1c6c9016d283dd6973","162":"e982a6c13e37677b83b8","397":"63bf2bf351718a57d1ca","509":"170f0f9aae5dfe35a15e","584":"9193c14a0703c7c07163","971":"052129a233a1610fb40a"}[chunkId] + ".js";
};